<template>
  <div>
    <PageAllow controller="SubAccounts" action="index" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="6" md="4">
            <SearcherKeyword
              ref="Keyword"
              v-model="options.keyword"
              @text="KeywordText($event)"
              :label="$t('SubAccount.Fields.name_or_account')"
            />
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-col>
                <!-- 新增分账账号 -->
                <v-btn
                  v-if="$permission.permissionAllow('SubAccounts', 'add')"
                  small
                  color="primary"
                  class="ms-1 float-end"
                  @click.stop="
                    editDialog = true;
                    mode = 'new';
                    currentItem = {
                      is_express: 0,
                      is_balance: 0,
                      is_core: 0,
                      is_service_charge: 0,
                      auto_flg: 0,
                    };
                  "
                >
                  <v-icon x-small class="pe-1">fa-plus</v-icon>
                  {{ $t("SubAccount.addAccount") }}
                </v-btn>
                <!-- 导出账号一览 -->
                <v-btn
                  v-if="$permission.permissionAllow('SubAccounts', 'export')"
                  small
                  color="print"
                  dark
                  @click.stop="exportExcel()"
                  class="ms-1 float-end"
                >
                  <v-icon x-small class="pe-1">fa-file-export</v-icon>
                  {{ $t("SubAccount.exportAccounts") }}
                </v-btn>
                <!-- 导入账号 -->
                <v-btn
                  v-if="$permission.permissionAllow('SubAccounts', 'import')"
                  small
                  color="print"
                  dark
                  @click.stop="ImportDialog = true"
                  class="ms-1 float-end"
                >
                  <v-icon x-small class="pe-1">fa-file-import</v-icon>
                  {{ $t("SubAccount.importAccounts") }}
                </v-btn>
                <!-- 汇付个人开户 -->
                <v-btn
                  v-if="
                    settings &&
                    settings.hfpay_sub_account_enable &&
                    $permission.permissionAllow('HfInterface', 'addUser')
                  "
                  small
                  color="print"
                  dark
                  @click.stop="
                    addDialog = true;
                    mode = 'new';
                  "
                  class="ms-1 float-end"
                >
                  <v-icon x-small class="pe-1">fa-file-import</v-icon>
                  {{ $t("SubAccount.hf_personal_account") }}
                </v-btn>
                <!-- 批量提现 -->
                <v-btn
                  v-if="
                    settings &&
                    settings.hfpay_sub_account_enable &&
                    $permission.permissionAllow('SubAccounts', 'batchCash')
                  "
                  small
                  color="print"
                  dark
                  @click.stop="
                    checkSubAccountCash();
                    checkCashDialog = true;
                  "
                  class="ms-1 float-end"
                >
                  <!-- <v-icon x-small class="pe-1">fa-file-import</v-icon> -->
                  {{ $t("SubAccount.batchCash") }}
                </v-btn>
                <!-- 金蝶批量推送凭证任务排队，跟着提现权限 -->
                <v-btn
                  v-if="
                    settings &&
                    settings.push_platform == 1018 &&
                    $permission.permissionAllow('HfInterface', 'withdraw')
                  "
                  small
                  color="print"
                  dark
                  @click.stop="pushDialog = true"
                  class="ms-1 float-end"
                >
                  <v-icon x-small class="pe-1">fa-file-import</v-icon>
                  {{ $t("SubAccount.kingdee_push_vouchers") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <!-- 选择银行 -->
                  <SearcherBanks v-model="banksSelected"></SearcherBanks>
                </v-col>
                <!-- 状态 -->
                <v-col cols="12" sm="6" md="4" class="d-flex mt-2">
                  <v-sheet class="transparent-background-color">
                    <div
                      class="caption grey--text input-chip-group-label"
                      :class="
                        $vuetify.theme.dark
                          ? 'text--lighten-1'
                          : 'text--darken-1'
                      "
                    >
                      {{ $t("SubAccount.status.title") }}
                    </div>
                    <v-chip-group v-model="options.delete_flgs" column multiple>
                      <v-chip
                        small
                        label
                        filter
                        class="me-1"
                        color="primary"
                        :value="0"
                      >
                        {{ $t("SubAccount.status.confirmed") }}
                      </v-chip>
                      <v-chip
                        small
                        label
                        filter
                        class="me-1"
                        color="accent"
                        :value="1"
                      >
                        {{ $t("SubAccount.status.granted") }}
                      </v-chip>
                    </v-chip-group>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="accounts"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          mobile-breakpoint="800"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.shop>
            {{ $consts.shopName() }}
          </template>
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.is_express="{ item }">
            {{ item.is_express | expressTypesText }}
          </template>
          <template v-slot:item.is_balance="{ item }">
            {{ item.is_balance | balanceTypesText }}
          </template>
          <template v-slot:item.actions="{ item, index }">
            <!-- 编辑 -->
            <v-tooltip
              top
              v-if="
                $permission.permissionAllow('SubAccounts', 'edit') &&
                item.actions.edit
              "
            >
              <!-- 权限待定 -->
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    editDialog = true;
                    currentItem = JSON.parse(JSON.stringify(item));
                    mode = 'edit';
                  "
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("SubAccount.action.edit") }}
                </v-btn>
              </template>
              <span>{{ $t("SubAccount.action.edit") }}</span>
            </v-tooltip>
            <!-- 提现 -->
            <v-tooltip top v-if="item.actions.cash">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="item.bank_code == 'EXTLKL'"
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    lklCashDialog = true;
                    lklCashPrice = null;
                    lklCurrentItem = JSON.parse(JSON.stringify(item));
                    lklAccountNumber = item.third_account_number;
                  "
                >
                  {{ $t("SubAccount.action.cash") }}
                </v-btn>
                <v-btn
                  v-else
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    cashDialog = true;
                    hf_withdraw = {};
                    cashPrice = null;
                    hfAccountNumber = item.account_number;
                  "
                >
                  {{ $t("SubAccount.action.cash") }}
                </v-btn>
              </template>
              <span>{{ $t("SubAccount.action.cash") }}</span>
            </v-tooltip>
            <!-- 农行查询余额 -->
            <v-tooltip top v-if="item.actions.balance">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  color="action"
                  class="px-2 me-2 mb-1"
                  :dark="!item.balanceLoading"
                  :loading="item.balanceLoading"
                  :disabled="item.balanceLoading"
                  @click.stop="getAbcBalance(item, index)"
                >
                  {{
                    $t(
                      item.balance_get
                        ? "SubAccount.action.balance_get"
                        : "SubAccount.action.balance",
                      [item.balance]
                    )
                  }}
                </v-btn>
              </template>
              <span>{{ $t("SubAccount.action.balance") }} </span>
            </v-tooltip>
            <!-- 失效 -->
            <v-tooltip
              top
              v-if="
                $permission.permissionAllow('SubAccounts', 'effect') &&
                item.actions.effect_no
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="danger"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    disableDialog = true;
                    currentItem = JSON.parse(JSON.stringify(item));
                  "
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("SubAccount.action.disabled") }}
                </v-btn>
              </template>
              <span>{{ $t("SubAccount.action.disabled") }}</span>
            </v-tooltip>
            <!-- 生效 -->
            <v-tooltip
              top
              v-if="
                $permission.permissionAllow('SubAccounts', 'effect') &&
                item.actions.effect_ok
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="alive"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    aliveDialog = true;
                    currentItem = JSON.parse(JSON.stringify(item));
                  "
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("SubAccount.action.alive") }}
                </v-btn>
              </template>
              <span>{{ $t("SubAccount.action.alive") }}</span>
            </v-tooltip>
            <!-- 畅捷通绑定 -->
            <v-tooltip
              top
              v-if="
                $permission.checkPushPlatformEnabled(
                  $permission.pushPlatforms.chanjet
                ) &&
                chanjetUrls &&
                chanjetUrls.SubAccount
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  target="_blank"
                  :href="chanjetUrls.SubAccount + item.id"
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("Oauth.bindChanjet")
                  }}<span v-if="item.chanjetToken">{{
                    $t("Oauth.binded")
                  }}</span>
                </v-btn>
              </template>
              <span>{{ $t("Oauth.bindChanjet") }}</span>
            </v-tooltip>
            <!-- 关联门店 -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  v-if="settings && settings.sub_account_enable == 2"
                  @click="
                    $router.push(
                      '/settings/sub-account-settings/sub-account/edit-shop/' +
                        item.id
                    )
                  "
                >
                  {{ $t("SubAccount.action.bind") }}
                </v-btn>
              </template>
              <span>{{ $t("SubAccount.action.bind") }}</span>
            </v-tooltip>
            <!-- 注册会员 -->
            <v-tooltip top v-if="item.actions.create_user">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    createUserDialog = true;
                    lklAccountNumber = item.account_number;
                  "
                >
                  {{ $t("SubAccount.action.create_user") }}
                </v-btn>
              </template>
              <span>{{ $t("SubAccount.action.create_user") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>

    <!-- 导入弹窗 -->
    <ImportExcelAlert
      v-model="ImportDialog"
      :objName="$t('SubAccount.Fields.account')"
      downloadTemplateUrl="download/template/分账账号导入模板.xlsx"
      @import="
        excelFile = $event;
        importExcel();
      "
    />
    <!-- 账号编辑弹窗 -->
    <v-dialog v-model="editDialog" width="600px">
      <v-card>
        <v-card-title class="mx-3">
          <v-spacer></v-spacer>
          {{ $t("SubAccount.Fields.account_info") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="editDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <!-- <ValidationObserver ref="observer"> -->
          <v-container>
            <!-- 分账类型 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.Fields.type") }}
                {{ $t("Global.colon") }}
                <Required :show="true" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <SearcherSubAccountType
                  v-model="currentItem.accountType"
                  :disabled="mode == 'edit'"
                ></SearcherSubAccountType>
              </v-col>
            </v-row>
            <!-- 银行 -->
            <v-row align="center" class="mt-0">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.Fields.bank") }}
                {{ $t("Global.colon") }}
                <Required :show="true" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <SearcherBank
                  v-model="currentItem.bank"
                  :disabled="mode == 'edit'"
                ></SearcherBank>
              </v-col>
            </v-row>
            <!-- 用户客户号 -->
            <v-row
              align="center"
              v-if="currentItem.bank && currentItem.bank.bank_code == 'EXTHF'"
              class="mt-0"
            >
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.Fields.user_number") }}
                {{ $t("Global.colon") }}
                <Required :show="true" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  :disabled="mode == 'edit'"
                  single-line
                  type="number"
                  v-model="currentItem.third_account_number"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <!-- 账号 -->
            <v-row align="center" class="mt-0">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.Fields.account") }}
                {{ $t("Global.colon") }}
                <Required :show="true" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  single-line
                  v-model="currentItem.account_number"
                  :disabled="mode == 'edit'"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <!-- 名称 -->
            <v-row align="center" class="mt-0">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.Fields.name") }}
                {{ $t("Global.colon") }}
                <Required :show="true" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field single-line v-model="currentItem.account_name">
                </v-text-field>
              </v-col>
            </v-row>
            <!-- 二级商户号 -->
            <v-row
              align="center"
              v-if="
                currentItem.bank &&
                currentItem.bank.bank_code != 'EXTWS' &&
                currentItem.bank.bank_code == 'EXTLKL' &&
                mode == 'edit'
              "
              class="mt-0"
            >
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  currentItem.bank.bank_code == "ABC"
                    ? $t("SubAccount.Fields.third_account_number_abc")
                    : currentItem.bank.bank_code == "EXTCCBSCAN"
                    ? $t("SubAccount.Fields.third_account_number_ccb")
                    : $t("SubAccount.Fields.third_account_number_other")
                }}
                {{ $t("Global.colon") }}
                <Required
                  :show="
                    currentItem.bank.bank_code == 'ABC' ||
                    currentItem.bank.bank_code == 'EXTCCBSCAN'
                  "
                  :mode="mode"
                />
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  single-line
                  v-model="currentItem.third_account_number"
                  :disabled="isLKLThirdAccountNumberDisabled"
                />
              </v-col>
            </v-row>
            <!-- 商户公钥（建行扫码） -->
            <v-row
              align="center"
              v-if="
                currentItem.bank && currentItem.bank.bank_code == 'EXTCCBSCAN'
              "
              class="mt-0"
            >
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.Fields.third_param") }}
                {{ $t("Global.colon") }}
                <Required
                  :show="currentItem.bank.bank_code == 'EXTCCBSCAN'"
                  :mode="mode"
                />
              </v-col>
              <v-col cols="9" md="7">
                <v-textarea v-model="currentItem.third_param" outlined>
                </v-textarea>
              </v-col>
            </v-row>
            <!-- 分行号（建行扫码） -->
            <v-row
              align="center"
              v-if="
                currentItem.bank && currentItem.bank.bank_code == 'EXTCCBSCAN'
              "
              class="mt-0"
            >
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.Fields.third_expand_one") }}
                {{ $t("Global.colon") }}
                <Required
                  :show="currentItem.bank.bank_code == 'EXTCCBSCAN'"
                  :mode="mode"
                />
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  single-line
                  v-model="currentItem.third_expand_one"
                />
              </v-col>
            </v-row>
            <!-- 是否默认运费分账账号 -->
            <v-row
              align="center"
              class="mt-0"
              v-if="settings && settings.sub_account_enable != 2"
            >
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.Fields.is_express") }}
                {{ $t("Global.colon") }}
                <Required :show="true" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <v-radio-group row v-model="currentItem.is_express">
                  <v-radio
                    v-for="stat in isExpress"
                    :key="stat.value"
                    :label="`${stat.text}`"
                    :value="stat.value"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <!-- 是否为默认余额支付账号  -->
            <v-row
              align="center"
              class="mt-0"
              v-if="settings && settings.sub_account_enable != 2"
            >
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.Fields.is_balance") }}
                {{ $t("Global.colon") }}
                <Required :show="true" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <v-radio-group row v-model="currentItem.is_balance">
                  <v-radio
                    v-for="stat in isBalance"
                    :key="stat.value"
                    :label="`${stat.text}`"
                    :value="stat.value"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <!-- 是否为核心账户 -->
            <v-row
              align="center"
              class="mt-0"
              v-if="settings && settings.sub_account_enable != 2"
            >
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.Fields.is_core") }}
                {{ $t("Global.colon") }}
                <Required :show="true" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <v-radio-group row v-model="currentItem.is_core">
                  <v-radio
                    v-for="stat in isBalance"
                    :key="stat.value"
                    :label="`${stat.text}`"
                    :value="stat.value"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <!-- 是否服务费账户 -->
            <v-row
              align="center"
              class="mt-0"
              v-if="settings && settings.service_charge_enable"
            >
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.Fields.is_service_charge") }}
                {{ $t("Global.colon") }}
                <Required :show="true" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <v-radio-group row v-model="currentItem.is_service_charge">
                  <v-radio
                    v-for="stat in isBalance"
                    :key="stat.value"
                    :label="`${stat.text}`"
                    :value="stat.value"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <!-- 是否自动分账 -->
            <v-row
              align="center"
              class="mt-0"
              v-if="settings && settings.lkl_auto_sub_account_enable"
            >
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.Fields.auto_flg") }}
                {{ $t("Global.colon") }}
                <Required :show="true" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <v-radio-group row v-model="currentItem.auto_flg">
                  <v-radio
                    v-for="stat in isBalance"
                    :key="stat.value"
                    :label="`${stat.text}`"
                    :value="stat.value"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="editDialog = false">
            {{ $t("SubAccount.Fields.cancel") }}
          </v-btn>
          <v-btn color="primary" depressed @click="submit()">
            {{ $t("SubAccount.Fields.submit") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 汇付个人开户弹窗 -->
    <v-dialog v-model="addDialog" width="600px">
      <v-card>
        <v-card-title class="mx-3">
          <v-spacer></v-spacer>
          {{ $t("SubAccount.Fields.account_info") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="addDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <!-- <ValidationObserver ref="observer"> -->
          <v-container>
            <!-- 姓名 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.name") }}
                {{ $t("Global.colon") }}
                <Required :show="true" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field single-line v-model="addItem.user_name">
                </v-text-field>
              </v-col>
            </v-row>
            <!-- 身份证号 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.id_card") }}
                {{ $t("Global.colon") }}
                <Required :show="true" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  single-line
                  v-model="addItem.id_card"
                  type="number"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <!-- 手机号 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.user_mobile") }}
                {{ $t("Global.colon") }}
                <Required :show="true" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  single-line
                  v-model="addItem.user_mobile"
                  type="number"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <!-- 分账类型 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.Fields.type") }}
                {{ $t("Global.colon") }}
                <Required :show="true" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <SearcherSubAccountType
                  v-model="addItem.accountType"
                ></SearcherSubAccountType>
              </v-col>
            </v-row>
            <!-- 银行 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.bank") }}
                {{ $t("Global.colon") }}
                <Required :show="true" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <SearcherBank
                  v-model="addItem.bank"
                  :disabled="true"
                ></SearcherBank>
              </v-col>
            </v-row>
            <!-- 分账账号名称 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.account_name") }}
                {{ $t("Global.colon") }}
                <Required :show="true" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field single-line v-model="addItem.account_name">
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="addDialog = false">
            {{ $t("SubAccount.Fields.cancel") }}
          </v-btn>
          <v-btn color="primary" depressed @click="save()">
            {{ $t("SubAccount.Fields.submit") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 确认是否失效弹窗 -->
    <v-dialog v-model="disableDialog" width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("$vuetify.alert") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="disableDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 text-center subtitle-1">
          {{ $t("SubAccount.disableHint") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="disableDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="accent" depressed @click="effectChange()">
            {{ $t("$vuetify.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 确认是否生效弹窗 -->
    <v-dialog v-model="aliveDialog" width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("$vuetify.alert") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="aliveDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 text-center subtitle-1">
          {{ $t("SubAccount.aliveHint") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="aliveDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="accent" depressed @click="effectChange()">
            {{ $t("$vuetify.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 触发金蝶凭证推送接口 -->
    <v-dialog v-model="pushDialog" width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("$vuetify.alert") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="pushDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 text-center subtitle-1">
          {{ $t("SubAccount.pushKingdeeVouchersHint") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="pushDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="accent" depressed @click="pushKingdeeVouchers()">
            {{ $t("$vuetify.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 汇付提现弹窗 -->
    <v-dialog v-model="cashDialog" width="600px">
      <v-card>
        <v-card-title class="mx-3">
          <v-spacer></v-spacer>
          {{ $t("SubAccount.action.cash") }}
          <v-spacer></v-spacer>

          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="cashDialog = false">
                fa-times</v-icon
              >
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-container>
            <v-row align="center">
              <!-- 账号 -->
              <v-col cols="6">
                <span class="font-weight-bold text-right">
                  {{ $t("SubAccount.Fields.account") }}
                  {{ $t("Global.colon") }}
                </span>
                <span class="green--text"> {{ hf_withdraw.acct_id }} </span>
              </v-col>
              <!-- 账号余额 -->
              <v-col cols="6">
                <span class="font-weight-bold text-right">
                  {{ $t("SubAccount.hfCash.balance") }}
                  {{ $t("Global.colon") }}
                </span>
                <span class="red--text"> {{ hf_withdraw.acct_balance }} </span>
              </v-col>
            </v-row>
            <v-row align="center">
              <!-- 可用余额 -->
              <v-col cols="6">
                <span class="font-weight-bold text-right">
                  {{ $t("SubAccount.hfCash.usable_balance") }}
                  {{ $t("Global.colon") }}
                </span>
                <span class="red--text"> {{ hf_withdraw.balance }} </span>
              </v-col>
              <!-- 可提现余额 -->
              <v-col cols="6">
                <span class="font-weight-bold text-right">
                  {{ $t("SubAccount.hfCash.cashable_balance") }}
                  {{ $t("Global.colon") }}
                </span>
                <span class="red--text"
                  >{{ hf_withdraw.cashTotal }}
                  <span v-if="hf_withdraw.cashFlg == 1">{{
                    $t("SubAccount.hfCash.cashTip")
                  }}</span>
                </span>
              </v-col>
            </v-row>
            <!-- 取现方式 -->
            <v-row align="center">
              <v-col cols="9" class="d-flex">
                <span class="font-weight-bold text-right">
                  {{ $t("SubAccount.hfCash.hf_cash_type") }}
                  {{ $t("Global.colon") }}
                </span>
                <v-autocomplete
                  v-model="hf_withdraw.cashTypeSelected"
                  color="primary"
                  hide-no-data
                  :items="$consts.cashType"
                  item-text="text"
                  item-value="value"
                  return-object
                  single-line
                  dense
                  hide-details
                ></v-autocomplete>
              </v-col>
            </v-row>
            <!-- 提现卡号 -->
            <v-row align="center">
              <v-col cols="9" class="d-flex">
                <span class="font-weight-bold text-right">
                  {{ $t("SubAccount.hfCash.hf_card_id") }}
                  {{ $t("Global.colon") }}
                </span>
                <v-autocomplete
                  v-model="hf_withdraw.cardSelected"
                  color="primary"
                  hide-no-data
                  :items="accountCards"
                  item-text="Description"
                  item-value="bindCardId"
                  return-object
                  single-line
                  dense
                  hide-details
                ></v-autocomplete>
              </v-col>
              <v-col cols="3" class="pa-0">
                <v-btn
                  color="primary"
                  depressed
                  small
                  v-if="$permission.permissionAllow('HfInterface', 'addUser')"
                  @click="
                    addCard = {};
                    bindCardDialog = true;
                    cashDialog = false;
                  "
                >
                  {{ $t("SubAccount.hfCash.hfBindCard") }}
                </v-btn>
              </v-col>
            </v-row>
            <!-- 提现金额 -->
            <v-row>
              <v-col cols="9" class="d-flex">
                <span class="font-weight-bold text-right">
                  {{ $t("SubAccount.hfCash.trans_amt")
                  }}{{ $t("Global.colon") }}
                </span>
                <v-text-field
                  v-model="cashPrice"
                  single-line
                  dense
                  hide-details
                  type="number"
                  min="0"
                  :prefix="$t('Global.money')"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="cashDialog = false">
            {{ $t("SubAccount.Fields.cancel") }}
          </v-btn>
          <v-btn color="accent" depressed @click="hfCashSubmit()">
            {{ $t("SubAccount.action.cash") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 拉卡拉提现弹窗 -->
    <v-dialog v-model="lklCashDialog" width="600px">
      <v-card>
        <v-card-title class="mx-3">
          <v-spacer></v-spacer>
          {{ $t("SubAccount.action.cash") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="lklCashDialog = false">
                fa-times</v-icon
              >
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <ValidationObserver ref="lklCash">
            <v-container>
              <v-row align="center">
                <!-- 账号 -->
                <v-col cols="6">
                  <span class="font-weight-bold text-right">
                    {{ $t("SubAccount.Fields.account") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <span class="green--text">
                    {{ lklCurrentItem.account_number }}
                  </span>
                </v-col>
                <!-- 账号余额 -->
                <v-col cols="6">
                  <span class="font-weight-bold text-right">
                    {{ $t("SubAccount.hfCash.balance") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("Global.money") }}
                  </span>
                  <span class="red--text">
                    {{ lklCurrentItem.available_amount }}
                  </span>
                </v-col>
              </v-row>
              <v-row align="center">
                <!-- 可用余额 -->
                <v-col cols="6">
                  <span class="font-weight-bold text-right">
                    {{ $t("SubAccount.hfCash.lakala_cash_fee") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("Global.money") }}
                  </span>
                  <span class="red--text">
                    {{ lklCurrentItem.lakala_cash_fee }}
                  </span>
                </v-col>
                <!-- 可提现余额 -->
                <v-col cols="6">
                  <span class="font-weight-bold text-right">
                    {{ $t("SubAccount.hfCash.cashable_balance") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("Global.money") }}
                  </span>
                  <span class="red--text">
                    {{ lklCurrentItem.cashTotal | formatMoney }}
                  </span>
                </v-col>
              </v-row>
              <!-- 提现卡号 -->
              <v-row align="center">
                <v-col cols="9" class="d-flex">
                  <span class="font-weight-bold text-right">
                    {{ $t("SubAccount.hfCash.hf_card_id") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('SubAccount.hfCash.hf_card_id')"
                    rules="required"
                    style="width: 80%"
                  >
                    <v-autocomplete
                      v-model="lklCurrentItem.cardSelected"
                      color="primary"
                      hide-no-data
                      :items="lklAccountCards"
                      item-text="Description"
                      item-value="bindCardId"
                      return-object
                      single-line
                      dense
                      :error-messages="errors"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>
                <v-col cols="3" class="pa-0">
                  <v-btn color="primary" depressed small @click="lklBandCard()">
                    {{ $t("SubAccount.hfCash.hfBindCard") }}
                  </v-btn>
                </v-col>
              </v-row>
              <!-- 到账时间 -->
              <v-row align="center">
                <v-col cols="9" class="d-flex">
                  <span class="font-weight-bold text-right">
                    {{ $t("SubAccount.lklCash.type") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('SubAccount.lklCash.type')"
                    style="width: 80%"
                    rules="required"
                  >
                    <v-autocomplete
                      v-model="lklCurrentItem.withdrawTypeSelected"
                      color="primary"
                      :items="$consts.lklCcashType"
                      item-text="text"
                      item-value="value"
                      return-object
                      single-line
                      dense
                      :error-messages="errors"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- 提现金额 -->
              <v-row>
                <v-col cols="9" class="d-flex">
                  <span class="font-weight-bold text-right">
                    {{ $t("SubAccount.hfCash.trans_amt")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('SubAccount.hfCash.trans_amt')"
                    style="width: 80%"
                    :rules="{
                      max_value: {
                        max: lklCurrentItem.cashTotal
                          ? lklCurrentItem.cashTotal
                          : 0,
                      },
                      min_value: { min: 0.01 },
                      required: { required: true },
                    }"
                  >
                    <v-text-field
                      v-model="lklCashPrice"
                      single-line
                      dense
                      type="number"
                      min="0"
                      :error-messages="errors"
                      :prefix="$t('Global.money')"
                    />
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="lklCashDialog = false">
            {{ $t("SubAccount.Fields.cancel") }}
          </v-btn>
          <v-btn color="accent" depressed @click.stop="lklCashAlert = true">
            {{ $t("SubAccount.action.cash") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 绑定取现银行卡弹窗 -->
    <v-dialog v-model="bindCardDialog" width="640px">
      <v-card>
        <v-card-title class="mx-3">
          <v-spacer></v-spacer>
          {{ $t("SubAccount.hfCash.hfBindCard") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="bindCardDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />

        <v-card-text>
          <!-- <ValidationObserver ref="observer"> -->
          <v-container>
            <!-- 用户客户号 -->
            <!-- <ValidationObserver ref="observer"> -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.Fields.user_number") }}
                {{ $t("Global.colon") }}
                <span class="red--text">*</span>
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field single-line v-model="addCard.account_number">
                </v-text-field>
              </v-col>
            </v-row>
            <!-- 银行卡号 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.hfCash.hfCard") }}
                {{ $t("Global.colon") }}
                <span class="red--text">*</span>
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field single-line v-model="addCard.bank_code">
                </v-text-field>
              </v-col>
            </v-row>

            <!-- 绑卡类型 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.hfCash.card_type") }}
                {{ $t("Global.colon") }}
                <span class="red--text">*</span>
              </v-col>
              <v-col cols="9" md="7">
                <v-autocomplete
                  v-model="addCard.card_type"
                  color="primary"
                  hide-no-data
                  :items="$consts.cardtype"
                  item-text="text"
                  item-value="value"
                  single-line
                  dense
                  hide-details
                ></v-autocomplete>
              </v-col>
            </v-row>
            <!-- 银行卡开户省份 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.hfCash.card_province") }}
                {{ $t("Global.colon") }}
                <span class="red--text">*</span>
              </v-col>
              <v-col cols="9" md="7">
                <v-autocomplete
                  v-model="addCard.card_province"
                  color="primary"
                  hide-no-data
                  :items="hf_province"
                  item-text="name"
                  item-value="code"
                  single-line
                  dense
                  hide-details
                ></v-autocomplete>
              </v-col>
            </v-row>
            <!-- 银行卡开户地区 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccount.hfCash.card_area") }}
                {{ $t("Global.colon") }}
                <span class="red--text">*</span>
              </v-col>
              <v-col cols="9" md="7">
                <v-autocomplete
                  v-model="addCard.card_area"
                  color="primary"
                  hide-no-data
                  :items="hf_city"
                  item-text="name"
                  item-value="code"
                  single-line
                  dense
                  hide-details
                ></v-autocomplete>
              </v-col>
            </v-row>
            <!-- </ValidationObserver> -->
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="bindCardDialog = false">
            {{ $t("SubAccount.Fields.cancel") }}
          </v-btn>
          <v-btn color="primary" depressed @click="hfCardSave()">
            {{ $t("SubAccount.Fields.submit") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 校验分账提现信息弹窗 -->
    <v-dialog v-model="checkCashDialog" width="800px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("SubAccount.batchCash") }}
          <v-spacer />
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="checkCashDialog = false">
                fa-times
              </v-icon>
            </template>
            <span>{{ $t("$vuetify.close") }}</span>
          </v-tooltip></v-card-title
        >
        <v-divider></v-divider>
        <v-data-table
          :headers="checkCashHeaders"
          :items="checkCashItems"
          :loading="loading"
          multi-sort
          class="elevation-0 px-6"
          fixed-header
          height="340px"
          :footer-props="footerProps"
        >
          <template v-slot:item.isBindCard="{ item }">
            <div class="d-flex mt-n2 mb-n3">
              <span v-if="item.bind_card_id">
                {{ $t("SubAccount.checkCash.yes") }}
              </span>
              <span v-else>
                {{ $t("SubAccount.checkCash.no") }}
              </span>
            </div>
          </template>
          <template v-slot:item.balance="{ item }">
            <div class="d-flex mt-n2 mb-n3">
              <span>
                {{ item.balance | formatMoney }}
              </span>
            </div>
          </template>
          <template v-slot:item.cash_total="{ item }">
            <div class="d-flex mt-n2 mb-n3">
              <span>
                {{ item.cash_total | formatMoney }}
              </span>
            </div>
          </template>
        </v-data-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="
              batchCash();
              cashResultDialog = true;
            "
            class="elevation-1"
          >
            {{ $t("SubAccount.checkCash.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 提现结果显示 -->
    <v-dialog v-model="cashResultDialog" width="800px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("SubAccount.cashResult") }}
          <v-spacer />
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="cashResultDialog = false"
              >
                fa-times
              </v-icon>
            </template>
            <span>{{ $t("$vuetify.close") }}</span>
          </v-tooltip></v-card-title
        >
        <v-divider></v-divider>
        <v-data-table
          :headers="cashResultHeaders"
          :items="cashResult"
          :loading="loading"
          multi-sort
          class="elevation-0 px-6"
          fixed-header
          height="340px"
          :footer-props="footerProps"
        >
          <template v-slot:item.success_flg="{ item }">
            <div class="d-flex mt-n2 mb-n3">
              <span>
                {{ item.success_flg | cashStatusText }}
              </span>
            </div>
          </template>
          <template v-slot:item.error_msg="{ item }">
            <div class="d-flex mt-n2 mb-n3">
              <span v-if="item.success_flg == 2">
                {{ item.error_msg }}
              </span>
              <span v-else> </span>
            </div>
          </template>
        </v-data-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="cashResultDialog = false"
            class="elevation-1"
          >
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 注册会员弹窗 -->
    <v-dialog v-model="createUserDialog" width="600px">
      <v-card>
        <v-card-title class="mx-3">
          <v-spacer></v-spacer>
          {{ $t("SubAccount.Fields.create_user_title") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="createUserDialog = false"
              >
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <!-- 账号 -->
              <v-row align="center" class="mt-0">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("SubAccount.Fields.out_member_no") }}
                  {{ $t("Global.colon") }}
                  <Required :show="true" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <v-text-field
                    single-line
                    v-model="lklAccountNumber"
                    readonly="readonly"
                  />
                </v-col>
              </v-row>
              <!-- 会员类型 -->
              <v-row align="center" class="mt-0">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("SubAccount.Fields.member_type") }}
                  {{ $t("Global.colon") }}
                  <Required :show="true" mode="new" />
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('SubAccount.Fields.member_type')"
                    rules="required"
                  >
                    <v-select
                      v-model="memberType"
                      :items="$consts.subAccountSettings.member_type"
                      item-value="value"
                      item-text="text"
                      :error-messages="errors"
                      single-line
                      dense
                      hide-details
                    ></v-select>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="createUserDialog = false">
            {{ $t("SubAccount.Fields.cancel") }}
          </v-btn>
          <v-btn color="primary" depressed @click="createUserSubmit()">
            {{ $t("SubAccount.Fields.submit") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogAlert
      v-model="lklCashAlert"
      :message="$t('SubAccount.lkCashAlertMessage')"
      persistent
      useConfirm
      @confirm="lklCashSubmit()"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Required from "@/components/plugins/Required";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import ImportExcelAlert from "./plugins/ImportExcelAlert";
import SearcherBank from "./plugins/SearcherBank";
import SearcherBanks from "./plugins/SearcherBanks";
import SearcherSubAccountType from "./plugins/SearcherSubAccountType";
import SubAccount from "@/api/sub_accounts";
import Chanjet from "@/api/chanjet";
import KingdeeWorker from "@/api/kingdee_worker";
import Consts from "@/consts.js";
import HfInterface from "@/api/hf_interface";
import DialogAlert from "@/components/plugins/DialogAlert";
import LakalaInterface from "@/api/lakala_interface";
import Payment from "@/api/payment";
import snackbar from "@/plugins/snackbar";

const defaultOptions = {
  keyword: "",
  bank_codes: [],
  delete_flgs: [0],
};
// 汇付个人开户默认选择汇付银行
const defaultAddItem = {
  bank: {
    bank_code: "EXTHF",
    bank_name: "汇付支付",
  },
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    Required,
    ValidationObserver,
    ValidationProvider,
    SearcherKeyword,
    SearcherBank,
    SearcherBanks,
    SearcherSubAccountType,
    ImportExcelAlert,
    DialogAlert,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.subAccountSettings"),
        disabled: false,
        href: "/settings/sub-account-settings/sub-account-type",
      },
      {
        text: i18n.t("SettingNav.subAccount"),
        disabled: true,
        href: "/settings/sub-account-settings/sub-account",
      },
    ],

    headers() {
      return [
        {
          text: i18n.t("SubAccount.Fields.type"),
          align: "start",
          sortable: false,
          value: "sub_account_type_name",
        },
        {
          text: i18n.t("SubAccount.Fields.bank"),
          align: "start",
          sortable: false,
          value: "bank_name",
        },
        {
          text: i18n.t("SubAccount.Fields.account"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "account_number",
        },
        {
          text: i18n.t("SubAccount.Fields.name"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "account_name",
        },
        {
          text: i18n.t("SubAccount.Fields.third_account_number"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "third_account_number",
        },
        {
          text: i18n.t("SubAccount.Fields.is_express"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "is_express",
        },
        {
          text: i18n.t("SubAccount.Fields.is_balance"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "is_balance",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },

    isExpress() {
      return Consts.subAccountSettings.express_types;
    },
    isBalance() {
      return Consts.subAccountSettings.balance_types;
    },
    accountCards() {
      return this.account_cards.map((detail) => {
        detail.Description = i18n.t("SubAccount.hfCash.description", [
          detail.bankShortChn,
          detail.cardNo,
        ]);
        return detail;
      });
    },
    lklAccountCards() {
      return this.lkl_account_cards.map((detail) => {
        detail.Description = i18n.t("SubAccount.hfCash.description", [
          detail.bank_name,
          detail.card_no,
        ]);
        return detail;
      });
    },
    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },
    checkCashHeaders() {
      return [
        {
          text: i18n.t("SubAccount.Fields.account"),
          align: "start",
          sortable: false,
          value: "account_number",
        },
        // {
        //   text: i18n.t("SubAccount.hfCash.hfCard"),
        //   align: "start",
        //   sortable: false,
        //   value: "cash_card",
        // },
        {
          text: i18n.t("SubAccount.hfCash.balance"),
          align: "start",
          sortable: false,
          value: "balance",
        },
        {
          text: i18n.t("SubAccount.hfCash.cashable_balance"),
          align: "start",
          sortable: false,
          value: "cash_total",
        },
        {
          text: i18n.t("SubAccount.hfCash.isBindCard"),
          align: "start",
          sortable: false,
          value: "isBindCard",
        },
      ];
    },
    cashResultHeaders() {
      return [
        {
          text: i18n.t("SubAccount.Fields.account"),
          align: "start",
          sortable: false,
          value: "account_number",
        },
        {
          text: i18n.t("SubAccount.checkCash.successFlg"),
          align: "start",
          sortable: false,
          value: "success_flg",
        },
        {
          text: i18n.t("SubAccount.checkCash.errorMsg"),
          align: "start",
          sortable: false,
          value: "error_msg",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState([
      "loading",
      "stickTableCols",
      "mainContentScrolled",
      "fixHeaderHeightInPx",
      "settings",
    ]),
  },

  mounted() {
    this.getAccountsFromAPI();
  },

  data: () => ({
    Keyword: "",
    extCodeKeyword: "",
    options: JSON.parse(
      sessionStorage.getItem("accounts-options")
        ? sessionStorage.getItem("accounts-options")
        : JSON.stringify(defaultOptions)
    ),
    paging: {},
    accounts: [],
    ImportDialog: false,
    excelFile: null,
    selectShop: {},
    import_type: 0,
    errorCount: 0,
    successCount: 0,
    error_order_id: [],
    editDialog: false,
    currentItem: {},
    banksSelected: [],
    mode: "",
    addItem: JSON.parse(JSON.stringify(defaultAddItem)),
    pushDialog: false,
    addDialog: false,
    delDialog: false,
    disableDialog: false,
    aliveDialog: false,
    accountKeyword: "",
    bank_codes: [],
    cashDialog: false,
    account_cards: [],
    lkl_account_cards: [],
    hfAccountNumber: "",
    createUserDialog: false,
    lklAccountNumber: "",
    isLKLThirdAccountNumberDisabled: false,
    memberType: null,
    lklCashDialog: false,
    lklCashPrice: null,
    lklCurrentItem: {},
    lklCashAlert: false,
    hf_withdraw: {},
    cardSelected: null,
    cashTypeSelected: null,
    cashPrice: null,
    bindCardDialog: false,
    addCard: {},
    hf_province: [],
    hf_city: [],
    province_code: "",
    checkCashDialog: false,
    checkCashItems: [],
    itemsPerPageOptions: 5,
    cashResult: [],
    cashResultDialog: false,
    chanjetUrls: [],
  }),

  watch: {
    addCard: {
      deep: true,
      handler() {
        if (this.addCard.card_province) {
          this.province_code = this.addCard.card_province;
          this.getCityFromAPI();
        }
      },
    },
    $route() {
      this.getAccountsFromAPI();
    },
    grantedStatus: {
      handler() {
        this.getAccountsFromAPI();
      },
    },
    options: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getAccountsFromAPI();
        sessionStorage.setItem(
          "accounts-options",
          JSON.stringify(this.options)
        );
      },
    },
    currentItem: {
      handler() {
        // console.log(this.currentItem);
      },
    },
    ImportDialog: {
      handler() {
        if (!this.ImportDialog && this.excelFile) {
          this.excelFile = null;
        }
      },
    },
    excelFile: {
      handler() {
        // console.log(this.excelFile);
      },
    },
    banksSelected: {
      handler() {
        this.options.bank_codes = this.banksSelected
          ? this.banksSelected.map((bank) => {
              return bank.bank_code;
            })
          : [];
        // console.log(this.banksSelected);
        // console.log(this.options.bank_codes);
      },
    },
    editDialog: {
      handler() {
        if (this.editDialog) {
          if (this.currentItem.bank_code == "EXTLKL") {
            if (this.currentItem.third_account_number) {
              this.isLKLThirdAccountNumberDisabled = true;
            }
          }
        } else {
          this.isLKLThirdAccountNumberDisabled = false;
        }
      },
    },
    cashDialog: {
      handler() {
        if (this.cashDialog == true) {
          this.getCardsFromAPI();
          this.getWithdrawFromAPI();
        }
      },
    },
    bindCardDialog: {
      handler() {
        this.getProvinceFromAPI();
      },
    },
    lklCashDialog: {
      handler() {
        if (this.lklCashDialog == true) {
          this.getLKLCardsFromAPI();
          this.getLKLQueryBalanceFromAPI();
        } else {
          this.lklAccountNumber = null;
          this.lklCurrentItem = {};
          this.lklCashPrice = null;
          this.$refs.lklCash.reset();
        }
      },
    },
    createUserDialog: {
      handler() {
        if (this.createUserDialog) {
          this.memberType = 2;
        } else {
          this.memberType = null;
          this.lklAccountNumber = "";
          this.$refs.observer.reset();
        }
      },
    },
  },

  methods: {
    resetSearch() {
      this.banksSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      // [this.$refs.Keyword].forEach((k) => {
      //   if (k) k.clear();
      // });
    },
    onSearch() {
      this.options = Object.assign({}, this.options);
    },
    getAccountsFromAPI() {
      Chanjet.getOauthUrl().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.chanjetUrls = response.data.urls;
          }
        }.bind(this)
      );
      SubAccount.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.paging = response.data.paging;
            var accounts = response.data.sub_accounts;
            // 将bank_code和bank_name整合到一个bank属性中
            this.accounts = accounts.map((detail) => {
              var bank = {
                bank_code: detail.bank_code,
                bank_name: detail.bank_name,
              };
              var type = {
                type: detail.sub_account_type,
                name: detail.sub_account_type_name,
              };
              if (
                detail.is_balance == null ||
                typeof detail.is_balance == "undefined" ||
                detail.is_balance == undefined
              ) {
                //默认余额支付账号否
                detail.is_balance = 0;
              }
              if (
                detail.is_core == null ||
                typeof detail.is_core == "undefined" ||
                detail.is_core == undefined
              ) {
                //是否为核心账号
                detail.is_core = 0;
              }
              if (
                detail.is_service_charge == null ||
                typeof detail.is_service_charge == "undefined" ||
                detail.is_service_charge == undefined
              ) {
                //是否账号
                detail.is_service_charge = 0;
              }
              return Object.assign({}, detail, {
                bank: bank,
                accountType: type,
              });
            });
          }
        }.bind(this)
      );
    },

    importExcel() {
      this.$store.dispatch("fullscreenLoading");
      if (!this.excelFile[0]) {
        this.$snackbar.error(i18n.t("SubAccount.import.noNullBank"));
        this.$store.dispatch("fullscreenLoadingStop");
      } else if (!this.excelFile[1]) {
        this.$snackbar.error(i18n.t("SubAccount.import.noNullFile"));
        this.$store.dispatch("fullscreenLoadingStop");
      } else {
        SubAccount.imports(this.excelFile[0].bank_code, this.excelFile[1]).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.info(i18n.t("SubAccount.import.success"));
              this.ImportDialog = false;
              this.getAccountsFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
      }
    },
    exportExcel() {
      SubAccount.exports(this.options);
    },
    submit() {
      this.$store.dispatch("fullscreenLoading");
      // console.log(this.currentItem);
      var data = {
        sub_account_type: this.currentItem.accountType.type,
        bank_code: this.currentItem.bank.bank_code,
        account_number: this.currentItem.account_number,
        account_name: this.currentItem.account_name,
        third_account_number: this.currentItem.third_account_number,
        is_express: this.currentItem.is_express,
        is_balance: this.currentItem.is_balance,
        is_core: this.currentItem.is_core,
        is_service_charge: this.currentItem.is_service_charge,
        auto_flg: this.currentItem.auto_flg,
      };
      if (this.currentItem.bank.bank_code == "EXTCCBSCAN") {
        // 建行扫码支付参数
        data.third_param = this.currentItem.third_param;
        data.third_expand_one = this.currentItem.third_expand_one;
      }
      // data;
      SubAccount.save(this.currentItem.id, data).then(
        function (response) {
          if (response) {
            if (response.data.status.isOK()) {
              this.editDialog = false;
              this.getAccountsFromAPI();
            }
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    //汇付个人开户
    save() {
      this.$store.dispatch("fullscreenLoading");
      HfInterface.save(this.addItem).then(
        function (response) {
          if (response) {
            if (response.data.status.isOK()) {
              this.addDialog = false;
              this.getAccountsFromAPI();
            }
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    KeywordText(e) {
      this.options.keyword = e;
    },
    effectChange() {
      this.$store.dispatch("fullscreenLoading");
      SubAccount.effect(this.currentItem.id).then(
        function (response) {
          if (response) {
            if (response.data.status.isOK()) {
              this.aliveDialog = false;
              this.disableDialog = false;
              this.getAccountsFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    // 汇付提现
    hfCashSubmit() {
      this.$store.dispatch("fullscreenLoading");
      // 传递的数据
      var data = {
        account_number: this.hfAccountNumber,
        trans_amt: this.cashPrice,
        hf_card_id: this.hf_withdraw.cardSelected
          ? this.hf_withdraw.cardSelected.bindCardId
          : "",
        hf_cash_type: this.hf_withdraw.cashTypeSelected
          ? this.hf_withdraw.cashTypeSelected.text
          : "",
      };
      HfInterface.hfCash(data).then(
        function (response) {
          if (response) {
            if (response.data.status.isOK()) {
              this.cashDialog = false;
            }
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    // 汇付绑定银行卡
    hfCardSave() {
      this.$store.dispatch("fullscreenLoading");
      // 传递的数据
      HfInterface.bindCard(this.addCard).then(
        function (response) {
          if (response) {
            if (response.data.status.isOK()) {
              this.bindCardDialog = false;
            }
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    // 获取账户卡号
    getCardsFromAPI() {
      HfInterface.queryCard(this.hfAccountNumber).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.account_cards = response.data.result.card_list;
          }
        }.bind(this)
      );
    },
    //账户余额查询
    getWithdrawFromAPI() {
      HfInterface.hfWithdraw(this.hfAccountNumber).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.hf_withdraw = Object.assign({}, response.data.result, {
              cashTypeSelected: this.$consts.cashType[0],
            });
            this.cashPrice = response.data.result.cashTotal;
          }
        }.bind(this)
      );
    },
    getAbcBalance(item, index) {
      item.balanceLoading = true;
      SubAccount.getAbcBalance(item.third_account_number).then(
        function (response) {
          item.balanceLoading = false;
          if (response.data.status.isOK()) {
            if (response.data.balance.ReturnCode == "0000") {
              item.balance_get = true;
              item.balance = response.data.balance.Balance;
            } else {
              this.$snackbar.error(response.data.balance.ErrorMessage);
            }
          }
          this.accounts.splice(index, 1, item);
        }.bind(this)
      );
    },
    // 获取银行卡开户省份
    getProvinceFromAPI() {
      HfInterface.hfProvince().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.hf_province = response.data.provice;
          }
        }.bind(this)
      );
    },
    // 获取银行卡开户城市
    getCityFromAPI() {
      HfInterface.hfCity(this.province_code).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.hf_city = response.data.city;
          }
        }.bind(this)
      );
    },
    pushKingdeeVouchers() {
      this.$store.dispatch("fullscreenLoading");
      KingdeeWorker.addJob({
        event: "push_order_vouchers",
        param: { sub_account_time: this.$datetimeUtils.formatTime(new Date()) },
      }).then(
        function (response) {
          if (response) {
            if (response.data.status.isOK()) {
              this.pushDialog = false;
              snackbar.success(
                i18n.t("SubAccount.pushKingdeeVouchersQueuedHint")
              );
            }
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    //校验分账提现信息
    checkSubAccountCash() {
      SubAccount.checkSubAccountCash(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.checkCashItems = response.data.sub_account;
            // console.log(this.checkCashItems);
          }
        }.bind(this)
      );
    },
    // 批量提现
    batchCash() {
      this.$store.dispatch("fullscreenLoading");
      var data = this.checkCashItems
        .filter((e) => e.cash_total > 0 && e.bind_card_id != null)
        .map((detail) => {
          return {
            account_number: detail.account_number,
            trans_amt: detail.cash_total,
            hf_card_id: detail.bind_card_id,
          };
        });
      SubAccount.batchCash(data).then(
        function (response) {
          if (response) {
            if (response.data.status.isOK()) {
              this.checkCashDialog = false;
              this.cashResult = response.data.cash_result;
            }
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    createUserSubmit() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            let data = {
              out_member_no: this.lklAccountNumber,
              member_type: this.memberType,
            };
            // data;
            LakalaInterface.createUser(data).then(
              function (response) {
                if (response) {
                  if (response.data.status.isOK()) {
                    this.createUserDialog = false;
                    window.open(response.data.result.url, "_blank");
                    this.getAccountsFromAPI();
                  }
                }
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
            this.$store.dispatch("fullscreenLoadingStop");
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    // 获取拉卡拉账户卡号
    getLKLCardsFromAPI() {
      LakalaInterface.queryCard({ member_no: this.lklAccountNumber }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.lkl_account_cards = response.data.result;
          }
        }.bind(this)
      );
    },
    // 拉卡拉账户余额查询
    getLKLQueryBalanceFromAPI() {
      LakalaInterface.queryBalance({ member_no: this.lklAccountNumber }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.lklCurrentItem = Object.assign({}, this.lklCurrentItem, {
              available_amount: response.data.result.available_amount / 100,
            });
            Payment.fetch({
              keys: ["lakala_cash_fee"],
              parse: 0,
            }).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.lklCurrentItem = Object.assign({}, this.lklCurrentItem, {
                    lakala_cash_fee:
                      response.data.settings.lakala_cash_fee / 100,
                  });
                  this.lklCurrentItem.cashTotal = (
                    this.lklCurrentItem.available_amount -
                    this.lklCurrentItem.lakala_cash_fee
                  ).toFixed(2);
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
    lklBandCard() {
      // data;
      LakalaInterface.bandCard({ member_no: this.lklAccountNumber }).then(
        function (response) {
          if (response) {
            if (response.data.status.isOK()) {
              this.lklCashDialog = false;
              window.open(response.data.result.url, "_blank");
            }
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    lklCashSubmit() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.lklCash.validate().then(
        async function (result) {
          if (result) {
            let data = {
              member_no: this.lklAccountNumber,
              bank_card_no: this.lklCurrentItem.cardSelected.card_id,
              amount: this.lklCashPrice,
              withdraw_type: this.lklCurrentItem.withdrawTypeSelected.value
            };
            LakalaInterface.cash(data).then(
              function (response) {
                if (response) {
                  if (response.data.status.isOK()) {
                    this.lklCashDialog = false;
                    this.$snackbar.success(i18n.t("SubAccount.lklCash.success"));
                    this.getAccountsFromAPI();
                  }
                }
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
            this.$store.dispatch("fullscreenLoadingStop");
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
  },
};
</script>